<template>
  <div class="not-found">
    <div class="not-found__box">
      <p class="not-found__code">404</p>
      <p class="not-found__desc">抱歉，您访问的页面不存在</p>
      <a class="not-found__btn" @click="goHome">返回首页</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/index')
    }
  }
}
</script>

<style lang="less" scoped>
.not-found {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  &__code {
    font-size: 120px;
    font-weight: bold;
    color: #FC5659;
    text-align: center;
    margin-bottom: 20px;
  }
  &__desc {
    font-size: 18px;
    color: #666;
    text-align: center;
    margin-bottom: 40px;
  }
  &__btn {
    display: block;
    width: 180px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: #FC5659;
    border-radius: 22px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    margin: 0 auto;
  }
}
</style>
